import Button from '@material-ui/core/Button';
import * as React from 'react';
import { Typography, FormControl, InputLabel, Input, Link } from '@material-ui/core';
import { LoginEnum } from 'src/constants/Enum/LoginEnum';
import { resetPasswordCall } from 'src/effects/api/api.userAuth';

export default class ResetPasswordComponent extends React.Component<any, any> {

    state = {
        password: '',
        confirmPassword: '',
        error: undefined,
        isPasswordFormatValid: true,
        isConfirmPasswordFormatValid: true        
    }

    constructor(props: any) {
        super(props);
        this.handleGotoLogin = this.handleGotoLogin.bind(this);
        this.handleResetPassword = this.handleResetPassword.bind(this);
        this.handleConfirmPassword = this.handleConfirmPassword.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
    }

    handleConfirmPassword = (e: any) => {
        this.setState({ confirmPassword: e.target.value, error: undefined });
    }

    handlePassword = (e: any) => {        
        this.setState({ password: e.target.value, error: undefined });
    }

    handleGotoLogin = () => {
        this.props.handleComponentRendering(LoginEnum.Login);
    }
    handleResetPassword = () => {
        this.setState({ error: undefined });
        this.setState({ isPasswordFormatValid: true });
        this.setState({ isConfirmPasswordFormatValid: true });

        if (this.state.password && this.state.confirmPassword) {
            if (this.state.password !== this.state.confirmPassword) {
                // show error
                this.setState({ error: 'Password and confirm password are not same' });
            }
            else {
                if (this.validate()) {
                    // call api
                    resetPasswordCall(
                        {
                            email_address: this.props.email,
                            new_password: this.state.password,
                            confirm_password: this.state.confirmPassword
                        }).then((res: any) => {
                            console.log(res);
                            this.handleGotoLogin();
                        })
                }                
            }
        }
        else {
            this.setState({ error: 'Please fill password and confirm password' });
        }

    }

    validateTextForScriptTag(text: any) {
        const re = /<script.*?>([\s\S]*?)<\/script>/
        return !re.test(String(text).toLowerCase());
    }

    validate() {
        let isDataValid = true;        

        if (!this.validateTextForScriptTag(this.state.password)) {
            this.setState({ isPasswordFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isPasswordFormatValid: true });
        }

        if (!this.validateTextForScriptTag(this.state.confirmPassword)) {
            this.setState({ isConfirmPasswordFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isConfirmPasswordFormatValid: true });
        }        

        return isDataValid;
    }

    render() {
        return (
            <>
                <div className="loginTitleSection">
                    <Typography component="h4" variant="title" align="center" gutterBottom={true} className="registerTitle">
                        Reset Password
                    </Typography>
                </div>

                <div className="loginContentSection">
                    {this.state.error && (
                        <span className="errorMessage">{this.state.error}</span>
                    )}
                    <form className="loginForm" autoComplete="off">
                        <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                            <InputLabel htmlFor="password">Enter New Password</InputLabel>
                            <Input
                                name="password"
                                type="password"
                                // id="password"
                                // autoComplete="current-password"
                                value={this.state.password/*  ? this.state.password : '' */}
                                onChange={this.handlePassword}

                            />
                            {this.state.password && !this.state.isPasswordFormatValid && <span className="errorMessage">Invalid Password.</span>}
                        </FormControl>
                        <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                            <InputLabel htmlFor="confirm-password"> Confirm New Password</InputLabel>
                            <Input name="confirmPassword"
                                type="password"
                                // id="confirmPassword"
                                // autoComplete="current-password"
                                value={this.state.confirmPassword/*  ? this.state.confirmPassword : '' */}
                                onChange={this.handleConfirmPassword}
                            />
                            {this.state.confirmPassword && !this.state.isConfirmPasswordFormatValid && <span className="errorMessage">Invalid Confirm Password.</span>}
                        </FormControl>
                    </form>

                    <Button
                        type="submit"
                        fullWidth={true}
                        variant="contained"
                        color="primary"
                        className="btn-black"
                        onClick={this.handleResetPassword}
                    >
                        Reset &nbsp; >
                    </Button>

                    <Link className="loginGoToLink" href="javascript:void(0)" onClick={this.handleGotoLogin}>Go to Login</Link>

                </div>


            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/login/forgotPassword/ResetPasswordComponent.tsx